import {useCallback} from 'react';
import {DEFAULT_CURRENCY, formatMoney} from '../common/currency';
import {userAPI} from '../services/UserServices';

export const useCurrency = () => {
    const {data: user} = userAPI.useGetUserDataQuery();
    const currency = user?.currency || DEFAULT_CURRENCY;
    const formatCurrency = useCallback((value: number | string) => formatMoney(value, currency), [currency]);

    return {currency, formatCurrency};
};
